import styled from 'styled-components';
import { useFormatAudienceName } from '../hooks/useFormatAudienceName';
import { Cell } from './Cell';

type NameCellProps = {
  name: string;
  rowIndex: number;
};

const StyledCell = styled(Cell)`
  && {
    width: 100%;
    padding-right: 0;
  }
`;

const StyledLabel = styled.span`
  white-space: nowrap;
`;

export const NameCell = ({ name, rowIndex }: NameCellProps) => {
  const formatName = useFormatAudienceName();

  return (
    <StyledCell data-test="audience-count-name" columnId="name" $rowIndex={rowIndex}>
      <StyledLabel>{formatName(name)}</StyledLabel>
    </StyledCell>
  );
};
